export interface OnboardingCaseRow {
    id: number;
    no: string;
    cifId: string;
    cifAccountName: string;
    scanType: string;
    hitDate: string;
    osDay: number;
    branch: string;
    channel: string;
    assign: string;
    status: string;
    action: string;
    isMyCase: boolean;
}

export const ONBOARDING_FIXTURES: OnboardingCaseRow[] = [
    {
        id: 1,
        no: 'OB-001',
        cifId: 'CIF12345',
        cifAccountName: 'John Doe',
        scanType: 'Individual',
        hitDate: '2024-01-15',
        osDay: 5,
        branch: 'Main',
        channel: 'Branch',
        assign: 'User1',
        status: 'pending',
        action: 'view',
        isMyCase: true
    },
    {
        id: 2,
        no: 'OB-002',
        cifId: 'CIF67890',
        cifAccountName: 'Jane Smith',
        scanType: 'Individual',
        hitDate: '2024-01-16',
        osDay: 3,
        branch: 'Branch A',
        channel: 'Online',
        assign: 'User1',
        status: 'in progress',
        action: 'view',
        isMyCase: true
    },
    {
        id: 3,
        no: 'OB-003',
        cifId: 'CIF11223',
        cifAccountName: 'Acme Corp Ltd',
        scanType: 'Entity',
        hitDate: '2024-01-17',
        osDay: 10,
        branch: 'Main',
        channel: 'Mobile',
        assign: 'User1',
        status: 'pending',
        action: 'view',
        isMyCase: true
    },
    {
        id: 4,
        no: 'OB-006',
        cifId: 'CIF99001',
        cifAccountName: 'David Lee',
        scanType: 'Individual',
        hitDate: '2024-01-10',
        osDay: 15,
        branch: 'Branch A',
        channel: 'Online',
        assign: 'User3',
        status: 'closed',
        action: 'view',
        isMyCase: false
    },
    {
        id: 5,
        no: 'OB-007',
        cifId: 'CIF22334',
        cifAccountName: 'Global Trade Inc',
        scanType: 'Entity',
        hitDate: '2024-01-08',
        osDay: 20,
        branch: 'Main',
        channel: 'Branch',
        assign: 'User3',
        status: 'closed',
        action: 'view',
        isMyCase: false
    }
];

export interface ActivityModel {
    type: 'activity' | 'comment';
    actor: string;
    action: string;
    timestamp: string;
    detail?: string;
}

export const ALL_ACTIVITY_FIXTURES: ActivityModel[] = [
    { type: 'activity', actor: 'Lanh Kongkosol', action: 'updated the case status to', timestamp: '2023-06-11T12:30:00' },
    { type: 'activity', actor: 'Dara Meas', action: 'assigned the case to', timestamp: '2023-06-10T09:15:00' },
    { type: 'activity', actor: 'Sokha Chan', action: 'updated the case status to', timestamp: '2023-06-08T16:45:00' },
    { type: 'comment', actor: 'Sokha Chan', action: 'added a comment', timestamp: '2023-06-08T14:05:00', detail: 'Please review the attached KYC documents before approval.' },
    { type: 'comment', actor: 'Dara Meas', action: 'added a comment', timestamp: '2023-06-06T10:20:00', detail: 'Customer provided additional onboarding documents for verification.' }
];

export interface FileModel {
    kind: 'jpg' | 'pdf' | 'doc';
    uploadedBy: string;
    uploadedDate: string;
    fileName: string;
}

export const FILE_FIXTURES: FileModel[] = [
    { kind: 'jpg', uploadedBy: 'Heng Sok', uploadedDate: '2024-10-28', fileName: 'ic_jpg.png' },
    { kind: 'pdf', uploadedBy: 'Heng Sok', uploadedDate: '2024-10-28', fileName: 'ic_pdf.png' },
    { kind: 'doc', uploadedBy: 'Dara Meas', uploadedDate: '2024-10-29', fileName: 'ic_doc.png' }
];
